import { useEffect, useState } from "react"
import { useEndpointProvider } from "../../Providers/EndpointProvider"
import { useBackendLinksProvider } from "../../Providers/BackendLinksProvider"

/* Clara tells time the way Data Review does: in the RECORDING's timezone, from the data
   object's metadata, with Data Review's own default when the archive does not say
   (Visualization.js: dataObjectMetadata.time_zone || "America/New_York").

   It used the browser's zone instead. On a machine whose clock differs from the
   recording's, "ICP above 20 between 0400 and 0700" measured the wrong three hours (10
   minutes instead of 43 on the SYNTH EVAL archive, 1 Oct), and the same chart read
   06:00 to 12:00 in the live graph and 10:00 to 16:00 once enlarged. */
export const DEFAULT_TIME_ZONE = "America/New_York"

const cache = new Map()

/* The recording's zone, fetched once per data object. Never throws: a failed lookup is
   Data Review's default, the same as an archive that does not say. */
export async function fetchRecordingTimeZone(endpointProvider, LINKS, dataObjectId) {
	if (!dataObjectId) return null
	const key = String(dataObjectId)
	if (!cache.has(key)) {
		try {
			const metadata = await endpointProvider.post(LINKS.VISUALIZE.GET_DATA_OBJECT_BY_ID, { data_object_id: Number(dataObjectId) })
			cache.set(key, metadata?.time_zone || DEFAULT_TIME_ZONE)
		} catch (error) {
			return DEFAULT_TIME_ZONE
		}
	}
	return cache.get(key)
}

export function useRecordingTimeZone(dataObjectId) {
	const endpointProvider = useEndpointProvider()
	const { LINKS } = useBackendLinksProvider()
	const [timeZone, setTimeZone] = useState(() => cache.get(String(dataObjectId)) || null)

	useEffect(() => {
		if (!dataObjectId) {
			setTimeZone(null)
			return undefined
		}
		let cancelled = false
		fetchRecordingTimeZone(endpointProvider, LINKS, dataObjectId).then(zone => {
			if (!cancelled) setTimeZone(zone)
		})
		return () => {
			cancelled = true
		}
	}, [dataObjectId, endpointProvider, LINKS])

	return timeZone
}
